import { IconDeviceMobile } from "@tabler/icons-react";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { MarketingHeader } from "@/components/misc/MarketingHeader";
import {
	MarketingContainer,
	MarketingShell,
} from "@/components/misc/marketing-layout";
import { MobileAppStoreLinks } from "@/components/misc/mobile-app-distribution";
import { config } from "@/data/config";
import {
	getMobileAppDistribution,
	hasMobileAppStoreLinks,
	isMobileAppEnabled,
} from "@/lib/mobile-app";
import { seo } from "@/utils/seo";

export const Route = createFileRoute("/_marketing/download")({
	beforeLoad: () => {
		if (!isMobileAppEnabled()) {
			throw redirect({ to: "/" });
		}
		const distribution = getMobileAppDistribution();
		if (!hasMobileAppStoreLinks(distribution)) {
			throw redirect({ to: "/" });
		}
	},
	component: RouteComponent,
	head: () =>
		seo({
			title: "Download app",
			description: `Download the ${config.siteName} mobile app for iOS and Android. Use the same account as the web product.`,
			keywords:
				"mobile app, ios, android, app store, google play, download, native app",
		}),
});

export function RouteComponent() {
	const distribution = getMobileAppDistribution();

	return (
		<MarketingShell>
			<section className="pt-20 pb-16 sm:pt-28 sm:pb-24">
				<MarketingContainer>
					<div className="mx-auto max-w-2xl text-center">
						<div className="mx-auto mb-6 flex size-14 items-center justify-center rounded-2xl border border-border/80 bg-muted/40">
							<IconDeviceMobile className="size-7 text-primary" aria-hidden />
						</div>
						<MarketingHeader
							align="center"
							title="Mobile"
							heading="Take it with you"
							description={`Install ${config.siteName} on your phone. Your teams, notifications, and account work the same as on the web—optimized for iOS and Android.`}
						/>
						{distribution ? (
							<MobileAppStoreLinks
								distribution={distribution}
								className="mt-10 justify-center"
							/>
						) : null}
						<p className="mt-8 text-sm text-muted-foreground">
							Already signed in on the web? Open the app and sign in with the
							same email. OAuth uses your configured mobile redirect URI on the
							backend.
						</p>
					</div>
				</MarketingContainer>
			</section>
		</MarketingShell>
	);
}
